import WelcomeOrgManager from '@/screens/WelcomeOrgManager';

export default function PrivateWelcomeOrgRoute() {
  return <WelcomeOrgManager />;
}
